import site from '../../../site';
import { connectedStore } from '../../../store';
import getGlobalsFromHTML from '../../../globals/helpers/get-globals-from-html';
import getGlobalSource from '../../../globals/helpers/get-global-source';
import getGlobalBySource from '../../../globals/selectors/global-by-source';
import hasGlobals from '../../../globals/verifiers/has-globals';
import constants from '../../constants';
import getMappedPageContainer from '../../../view/accessors/get-mapped-page-container';
import template from '../../../template';

const { TEXT_COLOR_OPTIONS_VARIABLE } = constants;

const checkIsCustomColorUsedInGlobal = (cssVariable, html) => {
  const store = connectedStore.get();
  const state = store.getState();
  const variables = template.selectors.getVariables(state);
  const globalsFromHTML = getGlobalsFromHTML(html).map((globalFromHTML) => {
    const source = getGlobalSource(globalFromHTML);
    return getGlobalBySource(state, source);
  });
  const { globalId } = variables[TEXT_COLOR_OPTIONS_VARIABLE][0];

  return globalsFromHTML.some((global) => {
    if (global.html.includes(cssVariable) && global.id !== globalId) return true;

    if (hasGlobals(global.html)) {
      return checkIsCustomColorUsedInGlobal(cssVariable, global.html);
    }

    return false;
  });
};

const isCustomColorUsedOnThePage = (cssVariable) => {
  const { html: activePageHTML } = site.accessors.getActivePage();
  const mappedPageContainer = getMappedPageContainer();

  return (
    mappedPageContainer.includes(cssVariable) || // On auto saving we need to prevent clean up then user is editing block
    activePageHTML.includes(cssVariable) ||
    checkIsCustomColorUsedInGlobal(cssVariable, activePageHTML)
  );
};

export default isCustomColorUsedOnThePage;
